import { render, staticRenderFns } from "./NewMatch.vue?vue&type=template&id=03ce0e62&scoped=true&"
import script from "./NewMatch.vue?vue&type=script&lang=js&"
export * from "./NewMatch.vue?vue&type=script&lang=js&"
import style0 from "./NewMatch.vue?vue&type=style&index=0&id=03ce0e62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ce0e62",
  null
  
)

export default component.exports